import { render, staticRenderFns } from "./ProgramsTable.vue?vue&type=template&id=61d095c4&"
import script from "./ProgramsTable.vue?vue&type=script&lang=ts&"
export * from "./ProgramsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VDataTable,VExpandXTransition})
